export function formatPreferredContact({ preferredContactMethod }: { preferredContactMethod?: string }): string {
  if (!preferredContactMethod) {
    return ''
  }

  switch (preferredContactMethod) {
    case 'phone':
      return 'Phone'
    case 'email':
      return 'Email'
    case 'sms':
      return 'Text'
    default:
      return ''
  }
}

export function mapPublicToPreferredContactMethod(preferredContactMethod: string): string {
  switch (preferredContactMethod.toLowerCase()) {
    case 'phone':
      return 'phone'
    case 'email':
      return 'email'
    case 'text':
    case 'sms':
      return 'sms'
    default:
      return ''
  }
}
